export default class Dropdown {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Dropdown;
		self.attachEvents();
	}

	attachEvents() {
    this.ToggleDropdown();
    this.CloseDropdown();
        this.UpdateClickedValue();
    }

    ToggleDropdown() {
        $(document).on('click mouseenter', '.js-dropdown', function(e) {
            const clickedToggle = $(e.target).closest('a[role="button"], label');

            if (clickedToggle.length === 0) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            const clickedDropdown = $('ul', this).first();
            const wasVisible = clickedDropdown.hasClass('is-visible');

            $('.js-dropdown > ul.is-visible').removeClass('is-visible');

            if (!wasVisible) {
                clickedDropdown.addClass('is-visible');
                $('body').addClass('dropdown-active');
            } else {
                $('body').removeClass('dropdown-active');
            }

            if ($('.js-dropdown > ul.is-visible').length === 0) {
                $('body').removeClass('dropdown-active');
            }
        });
    }

    CloseDropdown() {
        $(document).on('click', function(e) {
            if ($(e.target).closest('.js-dropdown').length) {
                return;
            }

            $('.js-dropdown > ul.is-visible').removeClass('is-visible');
            $('body').removeClass('dropdown-active');
        });

        $(document).on('mouseleave', '.dropdown-new', function() {

            if ($('.dropdown-new .is-visible').length === 0) {
                $('body').removeClass('dropdown-active');
					$('.dropdown-new').removeClass('is-visible');
            }
        });
    }

    UpdateClickedValue() {
        $(document).on('click', '.js-dropdown ul [data-value]', function(e) {
            e.preventDefault();
            let value = $(this).data('value');
            let icon = $(this).data('icon');

            if (typeof icon !== 'undefined') {
                var iconHTML = '<img src="'+ icon +'" width="21" height="21"/>';
                var returnHTML = iconHTML + ' ' + value;
            } else {
                var returnHTML = value;
            }
            $(this).closest('.js-dropdown').trigger('click');
            $(this).closest('.js-dropdown').find('[role=button]').first().html(returnHTML);
        });
    }

}
